export const BD_ADMINISTRATIVE_REGION_SUFFIX_PLURALIZATION_MAPPING = {
  '=1': 'Regierungsbezirk',
  'other': 'Regierungsbezirke'
};
export interface AdministrativeRegion {
  "id" : number;
  "name" : string;
  "color" : string;
}
